/**
 * 通用骨架屏元件
 * 用法：<SkeletonBlock className="h-4 w-24 rounded-full" />
 */

interface SkeletonBlockProps {
  className?: string;
}

/** 單一骨架矩形，帶流光掃過動畫 */
export function SkeletonBlock({ className = '' }: SkeletonBlockProps) {
  return (
    <div
      className={`relative overflow-hidden bg-gray-100 ${className}`}
      aria-hidden="true"
    >
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/70 to-transparent" />
    </div>
  );
}

/** 房源卡骨架（對應 LatestPropertiesSection 的大卡） */
export function PropertyCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-stone-100">
      {/* 圖片區 */}
      <SkeletonBlock className="h-48 w-full" />
      {/* 內容區 */}
      <div className="p-4 md:p-5 space-y-3">
        <SkeletonBlock className="h-4 w-4/5 rounded-full" />
        <SkeletonBlock className="h-3 w-1/2 rounded-full" />
        <div className="flex gap-2">
          <SkeletonBlock className="h-5 w-12 rounded-md" />
          <SkeletonBlock className="h-5 w-16 rounded-md" />
        </div>
        <div className="flex items-center justify-between pt-1">
          <SkeletonBlock className="h-6 w-28 rounded-full" />
          <SkeletonBlock className="h-4 w-10 rounded-full" />
        </div>
      </div>
    </div>
  );
}

/** 手機版小卡骨架（對應 MobilePropertiesSection 的 2欄卡） */
export function MobilePropertyCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
      <SkeletonBlock className="h-36 w-full" />
      <div className="p-2.5 space-y-2">
        <SkeletonBlock className="h-3 w-4/5 rounded-full" />
        <SkeletonBlock className="h-2.5 w-3/5 rounded-full" />
        <SkeletonBlock className="h-5 w-2/5 rounded-lg" />
      </div>
    </div>
  );
}

/** 文字行骨架 */
export function SkeletonText({
  lines = 3,
  className = '',
}: {
  lines?: number;
  className?: string;
}) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock
          key={i}
          className={`h-3 rounded-full ${i === lines - 1 ? 'w-4/5' : 'w-full'}`}
        />
      ))}
    </div>
  );
}
